var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"visible":_vm.isShow,"append-to-body":true,"fullscreen":true,"title":"查看大图"},on:{"update:visible":function($event){_vm.isShow=$event},"close":_vm.close}},[_c('div',{staticClass:"img-box"},[_c('img',{attrs:{"src":_vm.src,"alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }